import script from "./SkeletonBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonBlock.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonBlock.vue?vue&type=style&index=0&id=2e7416eb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e7416eb"]])

export default __exports__